import { render, staticRenderFns } from "./Infographic2.vue?vue&type=template&id=1c823299&scoped=true&"
import script from "./Infographic2.vue?vue&type=script&lang=js&"
export * from "./Infographic2.vue?vue&type=script&lang=js&"
import style0 from "./Infographic2.vue?vue&type=style&index=0&id=1c823299&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c823299",
  null
  
)

export default component.exports